import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { BarChart3 } from "lucide-react";

export const Route = createFileRoute("/admin/quality-metrics")({
  component: () => (
    <StubAdminPage
      icon={BarChart3}
      title="Quality Metrics"
      subtitle="On-time rate, cancellations, ratings"
    />
  ),
});
